import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  key: planTypes[planTypes.ZOOM_DEVICE$HEADSET],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZOOM_DEVICE$HEADSET),
      title: this.$t('billing.hw.headset.addon.title'),
      planType: planTypes.ZOOM_DEVICE$HEADSET,
      configDescription: 'configDescription',
      description: this.$t('billing.hw.headset.addon.desc'),
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      allPlanMap: state => state.ShoppingCart.allPlanMap
    }),
    ...mapGetters(['getSelectedPlans']),
    mx_planList() {
      return this.planMapFlat.filter((p) => p.type === planTypes.ZOOM_DEVICE$HEADSET);
    },
    mx_currentSellerId() {
      return this.mx_planList[0]?.__originData?.sellerId
    },
    mx_currentVendorData() {
      return this.allPlanMap.__vendorsData?.vendors?.find(item => item.id === this.mx_currentSellerId)
    },
    mx_returnPolicy() {
      return this.mx_currentVendorData?.returnUrl
    },
    mx_privacyPolicy() {
      return this.mx_currentVendorData?.privacyUrl
    },
    mx_rmaUrl() {
      return this.mx_currentVendorData?.rmaUrl
    },
    mx_helpUrl() {
      return this.mx_currentVendorData?.helpUrl
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    ...mapActions(['switchSelectPlanAction']),
    handleAddNewOne(data) {
      const { items } = data

      this.updateSelectPlan({
        plan_code: `${items[0].itemMarketId}`,
        cartInfo: { selected_number: 1 },
      });
    },
    async handleSwitchPlan(currentPlan, data) {
      const { items = [] } = data
      const newPlan = {
        plan_code: `${items[0]?.itemMarketId}`,
        cartInfo: { selected_number: 1 },
      }
      this.switchSelectPlanAction([currentPlan.plan_code, newPlan]);
    }
  }
};
